import styles from "./rolefilter.module.css";
import { ArrowRight, Filter, Plus, Search } from "react-feather";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

const RoleFilter = ({ setFilterData, setAddModalOpen }) => {
    const { user, isAuthenticated } = useAuth0();
    const [filterOpen, setFilterOpen] = useState(false);

    return (<div className={`${styles.SearchFilterSec}`}>
        <div className={`${styles.SearchCon}`}>
            <div className={`${styles.SearchConSec}`}>
                <Search />
                <input type="text" placeholder="Search" onChange={(e) => setFilterData(prev => { return { ...prev, searchKey: e.target.value } })} />
            </div>
        </div>

        <div className={`${styles.FilterSec}`}>
            <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
                <p className={`${styles.FilterTitle}`}>
                    Filters
                    <span onClick={(e) => setFilterOpen(false)}>
                        <ArrowRight />
                    </span>
                </p>
            </div>
            <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}>
                <Filter />
            </Link>
            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("role:create") > -1 && <Link className={`${styles.AddNoteBu}`} onClick={(e) => setAddModalOpen(true)}>
                <Plus /> <span>Role</span>
            </Link>}
        </div>
    </div>)
}

export default RoleFilter;